import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-strategy-portfolio-inyova-yellow',
  templateUrl: './strategy-portfolio-inyova-yellow.component.html',
  styleUrls: ['./strategy-portfolio-inyova-yellow.component.scss'],
  standalone: false
})
export class StrategyPortfolioInyovaYellowComponent {
  @Input() femaleLeadership: string;
}
